import React, {useState} from 'react';
import {Form, Input, Select, Switch, Button, Card, Row, Col, Typography, Modal, message, Space} from 'antd';
import {UserOutlined, PhoneOutlined, LockOutlined} from '@ant-design/icons';
import './Common.module.css';
import styles from './Common.module.css';
import {addUserRequest, editSchoolAdminRequest, editSchoolMemberRequest} from "../api";

const {Title} = Typography;
const {Option} = Select;

const { TextArea } = Input;
const EditAccountForm = (props) => {
  console.log(props.user)
  const [form] = Form.useForm();
  const [accountStatus, setAccountStatus] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(true);

  const onFinish = (values) => {
    console.log('提交的表单数据:', values);
    // 这里可以添加API调用或其他提交逻辑
    var userCode = props.user.username;
    var pwd = values.pwd==undefined||values.pwd==""?props.user.pwd:values.pwd;
    var username = values.userName==undefined||values.userName==""?props.user.name:values.userName;
    var status = values.accountStatus==undefined?props.user.status:values.accountStatus?"1":"3";
    var beizhu = values.beizhu==undefined||values.beizhu==""?props.user.beizhu:values.beizhu;
    editSchoolMemberRequest(
        userCode,
        pwd,
        username,
        status,
        beizhu,
        (data)=>{
          console.log("ffffffffffffffffffff")
          console.log(data)
          if(data.ret == 1) {
            props.refreshList();
            closeCommon()
          }
          else {
            message.warning(data.msg);
          }
        }

    )
  };


  const closeCommon = () => {
    props.closeCommonModal()
  };

  return (
      <Modal
          maskClosable={false}
          // visible={true}
          open={props.openStatus}
          onCancel={closeCommon}
          footer={null} // 设置 footer 为 null 移除默认按钮
          width={800}
          // className="add-account-container"
      >
        <Card className={styles["form-card"]} span={20}>
          <div className={styles["form-title"]}>编辑学校成员信息</div>
          <Form
              form={form}
              layout="horizontal"
              onFinish={onFinish}
              className="account-form"
          >
            <Form.Item
                label="学校名称"
                name="schoolName"
                rules={[{required: false, message: '请输入学校名称'}]}
                labelAlign="right"
                labelCol={{span: 5}}
            >
              <text>{props.user.school_name}</text>
            </Form.Item>

            <Form.Item
                label="学校地址"
                name="schoolAddress"
                rules={[{required: false, message: '请输入学校地址'}]}
                labelAlign="right"
                labelCol={{span: 5}}
            >
              <text>{props.user.dizhi}</text>
            </Form.Item>


            <Form.Item
                label="姓名"
                name="userName"
                rules={[{required: false, message: '请输入姓名'}]}
                labelAlign="right"
                labelCol={{span: 5}}
            >
              <Input
                  placeholder={props.user.name}
                  size="large"
              />
            </Form.Item>
            <Form.Item
                label="手机号（账号）"
                name="phoneNumber"
                labelAlign="right"
                labelCol={{span: 5}}
            >
              <text>{props.user.user_login}</text>
            </Form.Item>
            <Form.Item
                label="账号密码"
                name="pwd"
                rules={[{required: false, message: '请输入密码'}]}
                labelAlign="right"
                labelCol={{span: 5}}
            >
              <Input
                  placeholder="请输入密码"
                  size="large"
              />
            </Form.Item>
            <Form.Item
                label="账号状态"
                name="accountStatus"
                labelAlign="right"
                labelCol={{span: 5}}
            >
              <Switch
                  checked={props.checkedStatus}
                  onChange={(checked) => {
                  }}
                  // checkedChildren="开"
                  // unCheckedChildren="关"
                  // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}
                  style={{marginLeft: 10, marginRight: 10}}
                  defaultChecked={props.user.status==1}
              />
            </Form.Item>
            <Form.Item
                label="备注"
                name="beizhu"
                labelAlign="right"
                labelCol={{span: 5}}
            >
              <TextArea
                  placeholder='输入备注信息'

                  // value={tishiValue}
                  // onChange={changeTishiFn}
                  // readOnly={disableCreate}
              />
            </Form.Item>
            <Form.Item className={styles["form-actions"]}>

              <Button

                  size="large"
                  onClick={() => {
                    props.closeCommonModal();
                    form.resetFields()
                  }}
              >
                取消
              </Button>

              <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  style={{marginLeft: 16}}
              >
                确认
              </Button>

            </Form.Item>
          </Form>
        </Card>
      </Modal>
  );
};

export default EditAccountForm;
